import { string, boolean, object } from "yup";

export const ProductCaracteristiqueSchema = object({
  libelle: string().required("Libellé obligatoire!!"),
});
